'use client';

import * as a from "react";
import p$1 from "../lib/IconBase.es.js";
import a$1 from "../defs/ArrowCircleUp.es.js";
const o = a.forwardRef((e, c) => /* @__PURE__ */ a.createElement(p$1, { ref: c, ...e, weights: a$1 }));
o.displayName = "ArrowCircleUpIcon";
const p = o;
export {
  p as ArrowCircleUp,
  o as ArrowCircleUpIcon
};
